<div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-medium">
  <div class="cell cell-large-col-span-12" [innerHTML]="data.settings?.content"></div>
  <div class="cell cell-large-col-span-12 flex flex-justify-space-between">
    <a href="" class="small">Terms of use</a>
    <a href=""><open-svg-logo name="powered-by-open" class="small darkgrey"></open-svg-logo></a>
  </div>
</div>